export const mysteryShoppers = [
  {
    id: 1,
    name: '小琪',
    avatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20young%20Taiwanese%20woman%20with%20warm%20genuine%20smile%2C%20casual%20comfortable%20outdoor%20clothing%2C%20natural%20soft%20lighting%20portrait%20photography%2C%20clean%20neutral%20background%2C%20approachable%20and%20trustworthy%20appearance%2C%20lifestyle%20headshot%20style%20with%20warm%20color%20tones%20and%20professional%20yet%20relatable%20aesthetic%2C%20natural%20makeup%20and%20relaxed%20expression&width=200&height=200&seq=701&orientation=squarish',
    title: '資深神秘客',
    specialty: '美食、按摩',
    reviewCount: 62,
    badge: '金牌神秘客',
    badgeColor: 'bg-yellow-100 text-yellow-700',
  },
  {
    id: 2,
    name: 'Tessa',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylish%20Taiwanese%20woman%20with%20confident%20expression%20and%20modern%20fashion%20sense%2C%20professional%20portrait%20photography%20with%20soft%20bokeh%20background%2C%20elegant%20yet%20approachable%20appearance%2C%20natural%20lighting%20highlighting%20facial%20features%2C%20lifestyle%20influencer%20headshot%20style%20with%20contemporary%20aesthetic%20and%20warm%20inviting%20atmosphere%2C%20subtle%20smile%20and%20engaging%20eye%20contact&width=200&height=200&seq=702&orientation=squarish',
    title: '旅遊達人',
    specialty: '旅遊、住宿',
    reviewCount: 48,
    badge: '銀牌神秘客',
    badgeColor: 'bg-gray-100 text-gray-700',
  },
  {
    id: 3,
    name: 'Ping',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cheerful%20Taiwanese%20man%20with%20friendly%20demeanor%20and%20casual%20sporty%20style%2C%20outdoor%20natural%20lighting%20portrait%20with%20soft%20focus%20greenery%20background%2C%20authentic%20and%20relatable%20appearance%2C%20lifestyle%20photography%20capturing%20genuine%20personality%20and%20warmth%2C%20headshot%20style%20with%20natural%20color%20grading%20and%20comfortable%20approachable%20vibe%2C%20subtle%20confident%20smile&width=200&height=200&seq=703&orientation=squarish',
    title: '運動專家',
    specialty: '健身、戶外',
    reviewCount: 35,
    badge: '銅牌神秘客',
    badgeColor: 'bg-orange-100 text-orange-700',
  },
  {
    id: 4,
    name: 'Kayla',
    avatar: 'https://readdy.ai/api/search-image?query=A%20creative%20Taiwanese%20woman%20with%20artistic%20flair%20and%20unique%20personal%20style%2C%20soft%20studio%20lighting%20portrait%20with%20neutral%20background%2C%20expressive%20eyes%20and%20thoughtful%20expression%2C%20professional%20yet%20creative%20appearance%2C%20lifestyle%20headshot%20photography%20with%20warm%20tones%20and%20artistic%20composition%2C%20modern%20and%20fashionable%20aesthetic%20with%20genuine%20character&width=200&height=200&seq=704&orientation=squarish',
    title: '生活美學家',
    specialty: '美髮、美容',
    reviewCount: 53,
    badge: '金牌神秘客',
    badgeColor: 'bg-yellow-100 text-yellow-700',
  },
];